import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaEye } from 'react-icons/fa';

import EmailAPI from '../../api/EmailAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import EmailViewPopup from './EmailViewPopup';

class InnerEmailList extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).email;
    this.state = { inApiCall: true,  popup: false, emails: [] };
    this.html = null;
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }
  
  componentDidMount() { this.loadEmails(this.props.id); }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true,  emails: [] });
      this.loadEmails(props.id);
    }
  }

  loadEmails = id => { EmailAPI.getInnerList(this.props.type, id, this.onReceived, this.onFail); };

  onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onReceived = res => {
    if(this.props.onCount) {
      this.props.onCount('email', res.count);
    }
    this.setState({ inApiCall: false,  emails: res.data });
  }
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      EmailAPI.delete(this.state.emails[indx].id, this.onDeleteSuccess, this.onFail);
  });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Emails deleted successfully', 'success');
    this.props.reload();
  }

  vewDoc = async id => {
    //const res = await DocumentAPI.getPublicMediaUrl(id);
    //window.open(res.url, '_blank');
    this.html = id;
    this.setState({ ...this.state, popup: true });
  }

  hidePopUp = () => this.setState({ ...this.state, popup: false });

  showList = () => this.state.emails.map((email, _i) => (
    <tr key={`email_${_i + 1}`}>
      <td>{Util.serverStringToDisplayDateTime(email.created_date)}</td>
      <td>{Display.ModelLabelValue('user', email.created_by)}</td>
      <td>{Display.FieldValue(email, 'source', this.model.fields)}</td>
      <td>{Display.FieldValue(email, 'mail_from', this.model.fields)}</td>
      <td>{Display.FieldValue(email, 'mail_to', this.model.fields)}</td>
      <td>{Display.FieldValue(email, 'cc', this.model.fields)}</td>
      <td>{Display.FieldValue(email, 'subject', this.model.fields)}</td>
      <td>{Display.FieldValue(email, 'response', this.model.fields)}</td>
      <td>
        <span className="buttons add buttons-sm" onClick={() => this.vewDoc(email.html)}>
          <FaEye /> View
        </span>
        {/* this.Delete &&
          <span onClick={() => this.onDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
        */}
      </td>
    </tr>
  ));

  render() {
    let uiEmails = this.showList();
    if(this.state.emails.length === 0)
      uiEmails = <tr><td colSpan="9">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>Emails</h2>
          <EmailViewPopup show={this.state.popup} onHide={this.hidePopUp} html={this.html}/>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover size='sm'>
              <thead>
                <tr>
                  <th>Date Time</th>
                  <th>Sales Person</th>
                  <th>Source</th>
                  <th>From</th>
                  <th>To</th>
                  <th>CC</th>
                  <th>Subject</th>
                  <th>Response</th>
                  <th className="actionth">Action</th>
                </tr>
              </thead>
              <tbody>
                { uiEmails }
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default InnerEmailList;